import { prepend } from 'ramda';
import { firebaseDb } from './app';

export const unwrap = snapshot => {
  const val = snapshot.val();
  if (typeof val === 'string' || val instanceof String) {
    return val;
  }

  return {
    key: snapshot.key,
    ...val,
  };
};

export const setOnDisconnect = (path, value) => {
  return new Promise((resolve, reject) => {
    firebaseDb
      .ref(path)
      .onDisconnect()
      .set(value, error => (error ? reject(error) : resolve()));
  });
};

export const push = (path, value) => {
  const newRef = firebaseDb.ref(path).push();
  const { key } = newRef;
  return newRef.set(value).then(() => key);
};

export const remove = path => {
  return new Promise((resolve, reject) => {
    firebaseDb.ref(path).remove(error => (error ? reject(error) : resolve()));
  });
};

export const set = (path, value) => {
  return new Promise((resolve, reject) => {
    firebaseDb.ref(path).set(value, error => (error ? reject(error) : resolve()));
  });
};

export const update = value => {
  return new Promise((resolve, reject) => {
    firebaseDb.ref().update(value, error => (error ? reject(error) : resolve()));
  });
};

export const subscribeToValue = (path, actions) => {
  const ref = firebaseDb.ref(path);
  ref.off();
  ref.on('value', snapshot => {
    actions.update({ key: snapshot.key, item: snapshot.val() });
  });
};

export const getList = (path, actions) => {
  const ref = firebaseDb.ref().child(path);
  ref.get().then(snapshot => {
    actions.create({ key: snapshot.key, item: snapshot.val() });
  });
};

export const loadAndSubscribeToList = (path, actions) => {
  const ref = firebaseDb.ref(path);
  ref.off();

  ref.get().then(snapshot => {
    actions.load({ key: snapshot.key, item: snapshot.val() });

    ref.on('child_changed', childSnapshot => {
      actions.update({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });
    ref.on('child_removed', childSnapshot => {
      actions.delete({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });

    ref.limitToLast(1).on('child_added', childSnapshot => {
      actions.create({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });
  });
};

export const loadAndSubscribeToListWithOrder = (path, actions, orderPath = '') => {
  const ref = firebaseDb.ref(path).orderByChild(orderPath);

  ref.once('value').then(snapshot => {
    let list = [];
    snapshot.forEach(childSnapshot => {
      const { key } = childSnapshot;
      list = prepend({ item: childSnapshot.val(), key }, list);
    });
    actions.load({ item: list });

    ref.on('child_changed', childSnapshot => {
      actions.update({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });
    ref.on('child_removed', childSnapshot => {
      actions.delete({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });

    ref.limitToLast(1).on('child_added', childSnapshot => {
      actions.create({ item: unwrap(childSnapshot), key: childSnapshot.key });
    });
  });
};

export function subscribeToList(path, actions) {
  const ref = firebaseDb.ref(path);
  ref.off();

  ref.on('child_added', snapshot => {
    actions.create({ item: unwrap(snapshot), key: snapshot.key });
  });

  ref.on('child_changed', snapshot => {
    actions.update({ item: unwrap(snapshot), key: snapshot.key });
  });
  ref.on('child_removed', snapshot => {
    actions.delete({ item: unwrap(snapshot), key: snapshot.key });
  });
}

export function offConnection(path) {
  const ref = firebaseDb.ref(path);
  ref.off();
}



// WEBPACK FOOTER //
// ./src/services/firebase/utils.js